export const categories = [
    {
      id: 1,
      title: "Education",
      icon: require("../assets/images/education.png"),
      color: "#A95EC2",
    },
    {
      id: 2,
      title: "Healthcare",
      icon: require("../assets/images/healthcare.png"),
      color: "#FF768A",
    },
    {
      id: 3,
      title: "Shopping",
      icon: require("../assets/images/shopping.png"),
      color: "#EC60AB",
    },
    {
      id: 4,
      title: "Food",
      icon: require("../assets/images/food.png"),
      color: "#FF9E6D",
    },
    {
      id: 5,
      title: "Other",
      icon: require("../assets/images/entertainment.png"),
      color: "#FFCB5E",
    },
  ];